<template>
    <section class="py-16">
        <div class="mx-auto container">
            <h2 class="text-5xl text-dim_dark mb-12">
                Галерея работ
            </h2>
            <!--  -->
            <div class="grid grid-cols-2 gap-6">
                <div class="col-span-1">
                    <div class="grid grid-cols-2 gap-6">
                        <div class="col-span-2">
                            <div class="h-96 bg-[url('https://premier.nevado.ru/wp-content/uploads/2021/10/09-02-scaled-e1681210852204.jpg')] bg-gray-300 bg-center bg-no-repeat bg-cover"></div>
                        </div>
                        <div class="col-span-1">
                            <div class="h-96 bg-[url('https://premier.nevado.ru/wp-content/uploads/2021/10/09-02-scaled-e1681210852204.jpg')] bg-gray-300 bg-center bg-no-repeat bg-cover"></div>
                        </div>
                        <div class="col-span-1">
                            <div class="h-96 bg-[url('https://premier.nevado.ru/wp-content/uploads/2021/10/09-02-scaled-e1681210852204.jpg')] bg-gray-300 bg-center bg-no-repeat bg-cover"></div> 
                        </div>
                    </div>
                </div>
                <div class="col-span-1">
                    <div class="grid grid-rows-2 grid-flow-col gap-6">
                        <div class="row-span-2">
                            <div class="h-full bg-[url('https://premier.nevado.ru/wp-content/uploads/2021/10/09-02-scaled-e1681210852204.jpg')] bg-gray-300 bg-center bg-no-repeat bg-cover"></div>
                        </div>
                        <div class="col-span-1">
                            <div class="h-96 bg-[url('https://premier.nevado.ru/wp-content/uploads/2021/10/09-02-scaled-e1681210852204.jpg')] bg-gray-300 bg-center bg-no-repeat bg-cover"></div>
                        </div>
                        <div class="col-span-1">
                            <div class="h-96 bg-[url('https://premier.nevado.ru/wp-content/uploads/2021/10/09-02-scaled-e1681210852204.jpg')] bg-gray-300 bg-center bg-no-repeat bg-cover"></div> 
                        </div>
                    </div>
                </div>
            </div>
            <!--  -->
            <div class="text-center">
                <button class="col-start-2 px-20 rounded py-4 text-xl text-black bg-dim_gold_2 border border-solid border-dim_gold_2 hover:border-black hover:bg-transparent mt-8">
                            Смотреть ещё
                        </button>
            </div>
        </div>
    </section>
</template>